import React, { useState, useEffect } from 'react'
import Logo from '../../../images/rewampimages/Vector.png'
import { emiDetails } from '../../containers/Dashboard/DashboardActionCreator.component'
import Loader from '../Loader/Loader.component'
import { SaveTrnasactionDetailRazorpay, SaveTrnasactionDetailRazorpayPayment, getRazorpayPaymentDetailsById, getRazorpayPaymentDetailsByIdPaymentService } from '../../containers/Admin/AdminActionCreator.component'
import Popup from './Popup.component'
import moment from 'moment'
export default function TransactionPopupNew({ allDetail, admin, close }) {
    const [loader, setLoader] = useState(false)
    const [emiDetailsData, setEmiDetailsData] = useState([])
    const currentService = "RAZORPAY";
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [object, setObject] = useState({
        type: "",
        paymentMode: "",
        emiAmount: "",
        paymentId: "",
        emiOrderId: "",
        emiType: "",
        paymentType: "",
        penaltyWaived: 0.0,
        nachWaived: 0.0,
        paidDate: "",
    })

    useEffect(() => {
        emiDetailsFn()
    }, [])

    const handleObj = (e, type) => {
        if(type == "type" && e.target.value == "loan"){
            setObject((prev) => ({
                ...prev,
                "paymentType": "FULL"
            }))
            
        }
        setObject((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const emiDetailsFn = () => {
        setLoader(true)
        emiDetails(allDetail, callback => {
            setLoader(false)
            setEmiDetailsData(callback)
        })
    }

    const getEmiArray = () => {
        return emiDetailsData && emiDetailsData.length > 0
            ? emiDetailsData
                .filter(value => value?.STATUS !== "paid")
                .map(value => value?.emiId)
            : [];
    };

    const saveTransHandler = () => {
        const obj = {
            "userId": allDetail?.userId,
            "loanId": allDetail?.loanId,
            "transactionId": object?.paymentId,
            "paidAmount": String(object?.emiAmount),
            "paidDate": moment(object?.paidDate).format("DD-MM-YYYY"),
            "addedBy": admin?.emailId,
            "paymentType": object?.type == "emi" ? object?.paymentType : "FORECLOSE",
            "paymentMode": object?.paymentMode,
            // "emiIds": object?.type == "emi" ? [object?.emiType] || null : getEmiArray(),

        }
        if (object?.type == "emi") {
            obj.emiId = object?.emiType
        } else {
            obj.emiIds = getEmiArray()
        }
        console.log("obj", obj)
        setLoader(true)
        // SaveTrnasactionDetailRazorpay(obj, callback => {
        SaveTrnasactionDetailRazorpayPayment(obj, callback => {
            setLoader(false)
            if (callback == "success") {
                setpopup({ show: true, popupStatus: "Transaction Added Successfully" })
            } else {
                setpopup({ show: true, popupStatus: "error Adding transaction" })
            }
            removePopup()
        })
    }

    const getRazorpayPaymentDetailsByIdFn = () => {
        setLoader(true)
        getRazorpayPaymentDetailsByIdPaymentService(object.paymentId, allDetail.loanId, currentService, callback => {
            setLoader(false)
            console.log(callback)
            if (callback) {
                setObject({
                    ...object,
                    emiOrderId: callback?.order_id,
                    emiAmount: callback?.amount
                })
            }
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }


    return (
        <>
            <div className="background-blur details-new">
                <div className="popup-main small-popup container-fluid max-width-500px dbl-border" style={{ marginTop: '100px', width: '60%' }}>
                    {
                        loader ? <Loader /> : ''
                    }
                    {
                        popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ''
                    }
                    <div style={{ textAlign: 'right', cursor: 'pointer' }}>
                        <i className="fa fa-times" onClick={() => close()}></i>
                    </div>
                    <h4 style={{ color: '#000', marginTop: '-15px' }}><img src={Logo} style={{ width: '27px' }} />&nbsp;&nbsp;Transaction Details</h4>
                    <div className="row">
                    </div>
                    <div className="row form-group" style={{ marginTop: '20px' }}>
                        <div className="col-sm-4 col-xs-12">
                            <label className="font-12px" style={{ marginTop: '10px' }}>TRANSACTION TYPE</label>
                            <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.type} onChange={(e) => handleObj(e, "type")}>
                                <option value={""}>Select Type</option>
                                <option value={"emi"}>EMI</option>
                                <option value={"loan"}>Foreclose Loan</option>
                            </select>
                        </div>
                        {
                            object?.type === "emi" ?
                                <>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>EMI</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.emiType} onChange={(e) => handleObj(e, "emiType")}>
                                            <option value={""}>Select Type</option>
                                            {
                                                emiDetailsData && emiDetailsData?.length > 0 ?
                                                    emiDetailsData?.map((value, index) => {
                                                        if (value?.STATUS == "paid") return
                                                        return (
                                                            <option value={value?.emiId}>{`EMI-${index + 1} - ${value?.AMOUNT}`}</option>
                                                        )
                                                    })
                                                    : ''}
                                        </select>
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT MODE</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.paymentMode} onChange={(e) => handleObj(e, "paymentMode")}>
                                            <option value={""}>Select Mode</option>
                                            <option value={"APP"}>APP</option>
                                            <option value={"LINK"}>LINK</option>
                                            <option value={"CASH"}>CASH</option>
                                            <option value={"UPI"}>UPI</option>


                                        </select>
                                    </div>
                                </>
                                : ''}
                        {
                            object?.type === "loan" ?
                                <>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT ID</label>
                                        <input className="form-control" type='text' value={object?.paymentId} onChange={(e) => handleObj(e, "paymentId")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT MODE</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.paymentMode} onChange={(e) => handleObj(e, "paymentMode")}>
                                            <option value={""}>Select Mode</option>
                                            <option value={"APP"}>APP</option>
                                            <option value={"LINK"}>LINK</option>
                                            <option value={"CASH"}>CASH</option>
                                            <option value={"UPI"}>UPI</option>

                                        </select>
                                    </div>

                                </>
                                : ''}
                    </div>

                    {
                        object?.type === "emi" ?
                            <>
                                <div className="row form-group" style={{ marginTop: '15px' }}>

                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT ID</label>
                                        <input className="form-control" type='text' value={object?.paymentId} onChange={(e) => handleObj(e, "paymentId")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT DATE</label>
                                        <input className="form-control" type='date' value={object?.paidDate} onChange={(e) => handleObj(e, "paidDate")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAID AMOUNT</label>
                                        <input className="form-control" type='number' value={object?.emiAmount} onChange={(e) => handleObj(e, "emiAmount")} disabled />
                                    </div>
                                </div>
                                <div className="row form-group" style={{ marginTop: '15px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT TYPE</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.paymentType} onChange={(e) => handleObj(e, "paymentType")}>
                                            <option value={""}>Select Type</option>
                                            <option value={"PART"}>PART PAYMENT</option>
                                            <option value={"FULL"}>FULL PAYMENT</option>
                                        </select>
                                    </div>

                                </div>
                            </>
                            : ''}
                    {
                        object?.type === "loan" ?
                            <>
                                <div className="row form-group" style={{ marginTop: '15px' }}>



                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT ORDER ID</label>
                                        <input className="form-control" type='text' value={object?.emiOrderId} onChange={(e) => handleObj(e, "emiOrderId")} disabled />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT DATE</label>
                                        <input className="form-control" type='date' value={object?.paidDate} onChange={(e) => handleObj(e, "paidDate")} />
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAID AMOUNT</label>
                                        <input className="form-control" type='number' value={object?.emiAmount} onChange={(e) => handleObj(e, "emiAmount")} disabled />
                                    </div>
                                </div>

                                {/* <div className="row form-group" style={{ marginTop: '15px' }}>
                                    <div className="col-sm-4 col-xs-12">
                                        <label className="font-12px" style={{ marginTop: '10px' }}>PAYMENT TYPE</label>
                                        <select style={{ border: 'none' }} className="form-control" id="paymentMode" value={object?.paymentType} onChange={(e) => handleObj(e, "paymentType")}>
                                            <option value={""}>Select Type</option>
                                            <option value={"PART"}>PART PAYMENT</option>
                                            <option value={"FULL"}>FULL PAYMENT</option>
                                        </select>
                                    </div>

                                </div> */}

                            </>
                            : ''}


                    {
                        object?.type === "loan" || object?.type === "emi" ?
                            <div className="row text-center form-group">

                                {
                                  ((object?.emiOrderId !== "" && object?.emiOrderId != null && object?.emiOrderId !== undefined && object.type == "loan") &&  object?.paymentType !== "" && object?.paymentType != null && object?.paymentType !== undefined && object.paymentMode !== "" && object.paymentMode !== null && object.paymentMode !== undefined) || (
                                    object?.paymentType !== "" && object?.paymentType != null && object?.paymentType !== undefined && object.paymentMode !== "" && object.paymentMode !== null && object.paymentMode !== undefined
                                  )
                                        ?
                                        <button className="btn btn-primary" style={{ marginTop: '20px' }} id="transSubmitBtn" onClick={e => saveTransHandler()}>
                                            Save
                                        </button>
                                        :
                                        object?.paymentId !== "" && object?.paymentId != null && object?.paymentId !== undefined ?
                                            <button className="btn btn-primary" style={{ marginTop: '20px' }} id="transSubmitBtn" onClick={e => getRazorpayPaymentDetailsByIdFn()}>
                                                Fetch Payment
                                            </button>
                                            : ''
                                }
                            </div>
                            : ''}
                </div>
            </div>
        </>
    )
}
